import { LIST_TYPE } from "@/shared/types/atoms.types";
import React from "react";
import ListSection from "../atoms/ListSection";

interface TerminationListProps {}

export const terminationList = [
  {
    index: "6.1.",
    description:
      "These Affiliate Terms, and/or any terms as may be communicated to You in writing (emails included) are effective upon Your submission of an application or registration to the Affiliate Program on the Platform and shall remain in effect until either party terminates Your participation in the Affiliate Program (the “Term”). Your participation in the Affiliate Program may be terminated at any time by either party, with or without notice or cause.",
  },
  {
    index: "6.2.",
    description:
      "You are only eligible to earn Referral Rewards on Qualified Referrals occurring during the Term. Referral Rewards earned prior to the date of termination will be eligible for payment only if the subscription purchases on the Platform are not cancelled/suspended within thirty (30) days and comply with all of these Affiliate Terms. We may withhold Your final payment of Referral Rewards for a reasonable time to ensure that all Qualified Referrals are valid and payment from Referred Users are legitimate as determined by Graphy in its sole discretion. ",
  },
  {
    index: "6.3.",
    description:
      "Any Affiliate who violates these Affiliate Terms, Platform Terms, any terms as may be communicated to You in writing (emails included), or any applicable law or regulation will immediately forfeit any right to any and all accrued, but not yet received, Referral Rewards and such Affiliate’s access to the Platform and/or Affiliate Page shall be forthwith terminated. ",
  },
  {
    index: "6.4.",
    description:
      "Graphy reserves the right to remove an Affiliate from the Affiliate Program, and to terminate or suspend this their access to the Platform and/or Affiliate Page, at any time for any reason, in Graphy’s sole discretion. ",
  },
];

const TerminationList: React.FC<TerminationListProps> = () => {
  return (
    <div>
      {terminationList.map((data) => (
        <React.Fragment key={data.index}>
          <ListSection
            listIndex={data.index}
            listType={LIST_TYPE.LIST2}
            description={data.description}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

TerminationList.displayName = "TerminationList";

export default TerminationList;
